module.exports = __webpack_public_path__ + "6362f44ebc19b8c107e879b00d9b33c4.svg";